import React from 'react';
import Logo from '../../Logo/logo';
import { ICompanyResponse } from '../../../../../../Interfaces/responseTypes';
import CustomDrawer from '../../../../../../Components/Drawer/CustomDrawer/customDrawer';
import { useDrawerHooks } from '../../../../../../Components/Drawer/drawer-hooks';
import RestaurantDrawer from '../../Drawer/Main/restaurantDrawer';
import { useGeneralHooks } from '../../../../../../Hooks/hooks';
import { MenuIcon } from '../../../../../../Components/IconComponents';
import { getSmartBusinessTitle } from '../../../../../../Costants/companyNameSubtitleKeywords';
import styles from './mainHeaderStandart.module.scss';

interface IProps {
  data: ICompanyResponse,
  onCompanyUpdate: () => void,
}

const MainHeaderStandart: React.FC<IProps> = (props) => {
  const { data, onCompanyUpdate } = props;
  const { openDrawer, onCloseDrawer, onOpenDrawer } = useDrawerHooks();
  const { baseURL, navigate, mobileScreen, mediumScreen } = useGeneralHooks();
  const companyName = data.name || '';
  const { hasSmartSubtitle, mainTitle, subtitle } = getSmartBusinessTitle(companyName);

  return (
    <div className={styles.header}>
      <Logo
        imageUrl={data.logo}
        baseURL={baseURL!}
        onClick={() => navigate(`/my_business/${data.id!}`)}
        logoStyle={styles.headerLogo}
      />
      {
        hasSmartSubtitle
          ? (
            <div className={mobileScreen ? styles.mobileCenteredTitle : styles.smartCenteredTitle}>
              <p className={mobileScreen ? styles.mobileTitle : styles.smartTitle}>{mainTitle}</p>
              <p className={mobileScreen ? styles.mobileSubtitle : styles.smartSubtitle}>{subtitle}</p>
            </div>
          )
          : mobileScreen
            ? (
              <div className={styles.mobilePlainTitle}>
                <p className={styles.mobilePlainTitleText}>{companyName}</p>
              </div>
            )
            : (
              <p className={`${styles.title} ${companyName.length > 20 && !mediumScreen ? styles.longTitle : ''}`}>
                {companyName}
              </p>
            )
      }
      <div className={styles.menuIconBox}>
        <MenuIcon
          width={25}
          height={25}
          color="var(--icon-color, rgb(69, 110, 141))"
          onClick={onOpenDrawer}
        />
      </div>
      <CustomDrawer
        children={
          <RestaurantDrawer
            data={data}
            onCompanyUpdate={onCompanyUpdate}
          />
        }
        open={openDrawer}
        onClose={onCloseDrawer}
      />
    </div>
  )
}

export default MainHeaderStandart
